<app-dialog-container>
  <div fxLayout="column" fxLayoutAlign="center" fxLayoutGap="4">
    <!-- Cabeçalho e Botões -->
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div fxFlex="100" fxLayoutAlign="center center">
        <h1 mat-dialog-title> ADICIONE UM NOVO ACESSO </h1>
      </div>
      <div>
        <button *ngIf="typeCes === typeCesEnum.EDIT" mat-icon-button (click)="changeType(typeCesEnum.SHOW)">
          <mat-icon class="btn-show">visibility</mat-icon>
        </button>
      </div>
    </div>
    
    <!-- Campos de Entrada com espaçamento reduzido -->
    <div fxLayout="row" fxLayoutGap="8px">
      <app-input fxFlex="48" [config]="getFieldConfig('email')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input fxFlex="48" [config]="getFieldConfig('password')" [typeCes]="typeCes" [group]="form"></app-input>
    </div>

    <div fxLayout="row" fxLayoutGap="8px">
      <app-input fxFlex="20" [config]="getFieldConfig('type')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input fxFlex="26.8" [config]="getFieldConfig('system')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input fxFlex="26.8" [config]="getFieldConfig('paymentMethod')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input fxFlex="26.8" *ngIf="showPixKeyField" [config]="getFieldConfig('pixKey')" [typeCes]="typeCes" [group]="form"></app-input>
    </div>



    <div fxLayout="row"  fxLayoutGap="8px">
      <app-input fxFlex="48" [config]="getFieldConfig('acessDescription')" [typeCes]="typeCes" [group]="form"></app-input>
      <app-input fxFlex="48" [config]="getFieldConfig('fileAttachment')" [typeCes]="typeCes" [group]="form"></app-input>
    </div>

    <!-- Botão de Salvar -->
    <div fxLayout="row" fxLayoutAlign="end center" fxFlex="10">
      <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="onSubmit(form.value)">
        Salvar
      </button>
    </div>
  </div>
</app-dialog-container>
